<template>
  <div class="home">
    <!-- <van-button type="default">默认按钮</van-button> -->
  </div>
</template>

<script>
// @ is an alias to /src
import { Button } from "vant";
export default {
  name: "home",
  components: {
    [Button.name]: Button,
  },
};
</script>
